import * as React from "react";
import type { SVGProps } from "react";
const SvgDiscordIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M20.857 5.384s-1.72-1.82-5.623-2.084v.575s2.141-.125 4.792 2.485C18.025 4.92 15.17 4.018 12 4.018c-3.17 0-6.025.902-8.026 2.342 2.651-2.61 4.792-2.485 4.792-2.485V3.3c-3.904.264-5.623 2.084-5.623 2.084C.168 9.216 0 17.599 0 17.599c2.802 3.378 6.323 2.947 6.323 2.947l1.294-1.869c-1.668-.45-2.86-1.487-3.575-2.293 1.997 1.411 4.823 2.293 7.958 2.293s5.96-.882 7.958-2.293c-.716.806-1.907 1.842-3.575 2.293l1.294 1.869s3.52.43 6.323-2.947c0 0-.168-8.383-3.143-12.215ZM8.264 15.228c-1.125 0-2.036-.968-2.036-2.163 0-1.195.911-2.163 2.036-2.163 1.124 0 2.036.968 2.036 2.163 0 1.195-.912 2.163-2.036 2.163Zm7.473 0c-1.125 0-2.036-.968-2.036-2.163 0-1.195.911-2.163 2.036-2.163 1.124 0 2.036.968 2.036 2.163 0 1.195-.912 2.163-2.036 2.163Z"
    />
  </svg>
);
export default SvgDiscordIcon;
